import { LocalDate } from '@js-joda/core';
import { useMemo } from 'react';

import { AppointmentView } from '@dreryk/egabinet-dashboard-frontend-api';

import { Text } from '@dreryk/react-components';

import { StyledRegisteredAppointmentsCardCount } from './RegisteredAppointmentsCardCount.styled';

type RegisteredAppointmentsCardCountProps = {
   readonly appointmentsView: AppointmentView[];
};

export const RegisteredAppointmentsCardCount = (props: RegisteredAppointmentsCardCountProps): JSX.Element => {
   const todaysAppointment = useMemo(() => {
      const today = LocalDate.now();
      return props.appointmentsView.find((appointment) => appointment.appointmentDate.equals(today));
   }, [props.appointmentsView]);

   return (
      <Text testId={'registeredAppointmentsCount'}>
         <StyledRegisteredAppointmentsCardCount>
            {todaysAppointment?.appointmentCount ?? 0}
         </StyledRegisteredAppointmentsCardCount>
      </Text>
   );
};
